import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { AppState } from '../../..';
import {
  searchContractsByCustomer,
  resetPassword,
  searchRelatedContractsByCustomer,
  saveCustomerFiles,
  removeCustomerFile,
  relateContractToCustomer,
  unrelateContractToCustomer
} from '../../customer.actions';
import { CustomerDetailsComponentProperties, CustomerDetailsComponent } from './customer-details.component';
import { FileViewModel } from '@models/Document';
import { CustomerViewModel, CustomerContractModel } from '@models/Customer';
import { getById } from '@common/components/common.actions';
import { loadCustomerIntoDetails, getCustomerFromService } from '../../customer.actions';
import { getAccount } from '@common/components/credit-cards/credit-card.actions';

// This is used to translate the state of the page to the props on the component
function mapStateToProps(state: AppState): Partial<CustomerDetailsComponentProperties> {
  return {
    message: state.customer.message,
    customerVM: state.customer.customerVM,
    contractsLoading: state.customer.contractsLoading,
    contractsPageCount: state.customer.contractsPageCount,
    contractsPageNumber: state.customer.contractsPageNumber,
    contractsPageSize: state.customer.contractsPageSize,
    contractsResults: state.customer.contractsResults,
    relatedContractsLoading: state.customer.relatedContractsLoading,
    relatedContractsPageCount: state.customer.relatedContractsPageCount,
    relatedContractsPageNumber: state.customer.relatedContractsPageNumber,
    relatedContractsPageSize: state.customer.relatedContractsPageSize,
    relatedContractsResults: state.customer.relatedContractsResults
  };
}

// This should create proxy wrappers for actions used by the component
function mapDispatchToProps(dispatch: Dispatch<AppState>): Partial<CustomerDetailsComponentProperties> {
  return {
    getCustomer: (id: number) => {
      dispatch(getById<CustomerViewModel>(id, getCustomerFromService)).then(customer => {
        if (!customer) {
          return;
        }
        dispatch(loadCustomerIntoDetails(customer));
        // TODO: dispatch(getCustomerCreditCards)
        if (customer.accountId) {
          dispatch(getAccount(customer.accountId));
        }
      });
    },
    getContracts: (id, pageNumber, pageSize) => dispatch(searchContractsByCustomer(id, pageNumber, pageSize)),
    getRelatedContracts: (id, pageNumber, pageSize) =>
      dispatch(searchRelatedContractsByCustomer(id, pageNumber, pageSize)),
    uploadFiles: (customerId: number, fileVMs: FileViewModel[]) => dispatch(saveCustomerFiles(customerId, fileVMs)),
    removeFile: (customerId: number, fileId: number) => dispatch(removeCustomerFile(customerId, fileId)),
    resetPassword: (accountId: number) => dispatch(resetPassword(accountId)),
    onSaveClick: (customerContract: CustomerContractModel) => {
      dispatch(relateContractToCustomer(customerContract)).then(() => {
        dispatch(searchRelatedContractsByCustomer(customerContract.customerId, 1, 10));
      });
    },
    removeRelated: (customerContract: CustomerContractModel) => {
      dispatch(unrelateContractToCustomer(customerContract)).then(() => {
        dispatch(searchRelatedContractsByCustomer(customerContract.customerId, 1, 10));
      });
    }
  };
}

// Connect function "wires" both of the map functions and returns a wrapper container for the component
export const CustomerDetails = connect(
  mapStateToProps,
  mapDispatchToProps
)(CustomerDetailsComponent);



// WEBPACK FOOTER //
// ./src/customer/_components/customer-details/customer-details.container.ts